'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _querystring = require('../../utils/querystring');

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

var _editor = require('../editor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$.fn.DataTable.Api.register('name()', function () {
	return this.init().name;
});

$.fn.DataTable.Api.register('primaryKey()', function () {
	return this.init().rowId || 'id';
});

$.fn.DataTable.Api.register('editor()', function () {
	return (0, _editor.getEditor)(this.table().node());
});

$.fn.DataTable.Api.register('sumCellShow()', function () {
	$(this.table().header()).find('tr.column-sums-error').hide();
	$(this.table().header()).find('tr.column-sums').show();
});

$.fn.DataTable.Api.register('sumCellError()', function (text) {
	$(this.table().header()).find('tr.column-sums').hide();
	$(this.table().header()).find('tr.column-sums-error').show().children(":first").text(text || '(Sum is not supported for current filter)');
});

$.fn.DataTable.Api.register('rowId()', function (rowData) {
	var id = rowData && rowData[this.primaryKey()];
	if (id) {
		return this.name() + '_row_' + id;
	}
});

/**
 * Use this API method to update query string parameters for ajax URL.
 *
 * Usage:
 *
 * $('#myTable').DataTable().query(qs => { qs.myParam = 'newValue'; });
 */
$.fn.DataTable.Api.register('query()', function (dataOrCallback) {
	return this.iterator('table', function (ctx) {
		var url = this.ajax.url();
		var cb = typeof dataOrCallback !== 'function' ? function (qs) {
			if ((typeof dataOrCallback === 'undefined' ? 'undefined' : _typeof(dataOrCallback)) === 'object') {
				(0, _assign2.default)(qs, dataOrCallback);
			}
		} : dataOrCallback;

		url = (0, _querystring.update)(url, cb);
		this.ajax.url(url);
	});
});

/**
 * Returns object with enum values for the given column.
 *
 * Usage:
 * $('#myTable').DataTable().enumValues(2);
 */
// $.fn.DataTable.Api.register('enumValues()', function(columnSelector) {
//     const column = this.column(columnSelector);
//     return column && column.enumValues();
// });


$.fn.DataTable.Api.register('clearFilters()', function () {
	// clear custom/external filters
	$(this.init().customFilters).each(function () {
		$(this).val('');
	});

	// clear global filter
	this.search('');

	// clear column filters
	this.columns().every(function () {
		this.search('');
	}).draw();
});


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/api/table-extensions.js
// module id = 477
// module chunks = 0